import React, { useEffect, useRef, useState } from "react";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { formats, isEmptyHtml } from "../Utils/richTextEditor";
import {
  emojisCategories,
  ReactIcon,
} from "./Sav/NewTicketSav/ChatContainer/EmojiPickerContainer";
import { SendMessageIcon } from "./Common/icons/SendMessageIcon";
import EmojiPicker from "emoji-picker-react";
import { useTranslation } from "react-i18next";
import AttachmentInput from "./Sav/NewTicketSav/ChatContainer/AttachmentInput";
import MessageMediaPreview from "./Sav/NewTicketSav/ChatContainer/MessageMediaPreview";
import EditMessageMediaPreview from "./Sav/NewTicketSav/ChatContainer/EditMessageMediaPreview";
import { Spinner } from "react-bootstrap";

const RichTextEditor = ({
  loading,
  handleChange,
  newMessage,
  setNewMessage,
  handleSubmit,
  edit,
}) => {
  const { t, i18n } = useTranslation("common");
  const emojiRef = useRef(null);
  const ref = useRef(null);
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  const [modules] = useState({
    toolbar: {
      container: [
        ["bold", "italic", "underline", "strike"],
        [{ list: "bullet" }, { list: "ordered" }],
        ["clean"],
        ["link"],
      ],
    },
  });

  const addEmoji = (event) => {
    const quillInstance = ref.current.getEditor();
    quillInstance.focus();
    const range = quillInstance.getSelection(); // Get current cursor position

    quillInstance.insertEmbed(
      range?.index || 0,
      "image",
      event.imageUrl,
      Quill.sources.USER
    );
    quillInstance.setSelection(range.index ? range.index + 1 : 1); // Move cursor forward

    const updatedValue = quillInstance.root.innerHTML;
    setShowEmojiPicker(false);
    setNewMessage((prev) => ({
      ...prev,
      text: updatedValue,
    }));
  };

  // const onSubmit = () => {
  //   if (loading) return;
  //   handleSubmit();
  //   if (ref?.current) {
  //     const quillInstance = ref.current.getEditor();
  //     quillInstance.setContents([]);
  //   }
  //   setNewMessage({ text: "", attachments: [] });
  // };

  // const onKeyDown = (event) => {
  //   if (event.key === "Enter" && !event.shiftKey) {
  //     onSubmit();
  //   }
  // };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (emojiRef.current && !emojiRef.current.contains(event.target)) {
        setShowEmojiPicker(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="formContainer position-sticky w100 z-9999">
      {edit ? (
        <EditMessageMediaPreview
          attachments={newMessage?.attachments}
          setAttachments={(updatedAttachments) =>
            setNewMessage({ ...newMessage, attachments: updatedAttachments })
          }
        />
      ) : (
        <MessageMediaPreview
          attachments={newMessage?.attachments}
          setAttachments={(updatedAttachments) =>
            setNewMessage({ ...newMessage, attachments: updatedAttachments })
          }
        />
      )}
      <div className="position-relative text-editor-container">
        <ReactQuill
          ref={ref}
          formats={formats}
          modules={modules}
          theme="snow"
          value={newMessage?.text}
          onChange={(value) => {
            handleChange({ target: { name: "text", value } });
          }}
          // onKeyDown={onKeyDown}
          preserveWhitespace
          className="text-editor auto-height"
        />
        <div className="actions d-flex align-items-center flex-column position-absolute bottom-0 end-0">
          <AttachmentInput name="attachments" handleChange={handleChange} />
          <div ref={emojiRef} className="d-flex align-items-center">
            <button
              type="button"
              onClick={() => setShowEmojiPicker((val) => !val)}
              className="bg-transparent size-22px alignC border-darkGrey br5 border-0"
            >
              <ReactIcon />
            </button>
            <div className="position-absolute right-0 bottom-0 mb-5">
              <EmojiPicker
                open={showEmojiPicker}
                height={350}
                reactionsDefaultOpen
                previewConfig={{
                  defaultCaption: "",
                  showPreview: false,
                }}
                searchPlaceHolder={t("Search")}
                categories={
                  i18n.language?.toLowerCase()?.includes("fr") &&
                  emojisCategories
                }
                onEmojiClick={addEmoji}
                hiddenEmojis={["1f1ee-1f1f1"]}
                reactions={[
                  "1f44d",
                  "1f44e",
                  "1f64f",
                  "2764-fe0f",
                  "1f602",
                  "2705",
                  "274c",
                ]}
              />
            </div>
          </div>
          <button className="border-0">
            {!edit &&
              (loading ? (
                <Spinner animation="border" size="sm" variant="blue-800" />
              ) : (
                <SendMessageIcon
                  onClick={handleSubmit}
                  disabled={
                    (isEmptyHtml(newMessage.text) &&
                      !newMessage?.attachments?.length > 0) ||
                    loading
                  }
                />
              ))}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RichTextEditor;
